(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('SpecializzazioneDetailController', SpecializzazioneDetailController);

    SpecializzazioneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Specializzazione'];

    function SpecializzazioneDetailController($scope, $rootScope, $stateParams, previousState, entity, Specializzazione) {
        var vm = this;

        vm.specializzazione = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:specializzazioneUpdate', function(event, result) {
            vm.specializzazione = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
